<template lang="pug">
b-modal(v-model="showModal", size="md", centered  scrollable)
    template(#modal-header)
        div(class="d-flex justify-content-between w-100 align-items-center")
            div(class="d-flex flex-column align-items-start")
                h5.mb-0.font-weight-bold Submission Details
                small.text-muted(v-if="submission?.clientName") {{ submission.clientName }}
            div(class="d-flex" style="gap: 0.5rem;")
                b-button(variant="danger" style="width: fit-content;" @click="deleteSubmission(submission?.id,submission?.eventID,false)" :disabled="loading")
                    b-icon(icon="trash-fill" v-if="!loading")
                    b-spinner(v-else small)
                //- b-button( variant="primary" style="width: fit-content;" disabled)
                //-     b-icon(icon="printer")
                b-button( variant="outline-primary" style="width: fit-content;" @click="showEditModal = true" :disabled="loading")
                    b-icon(icon="pencil-fill")
            

    .container.submission-body
            div(v-if="event.isSingleDay && submission.singleDay" class="d-flex flex-column" style="")
                 
                div(v-for="person in uniquePeopleSingleDay" :key="person"  )
                    div(class="person-header" v-if="person!=='Other Persons'")
                        span.avatar
                            b-icon-person-badge
                        div(class="d-flex flex-column align-items-start")
                            b-card-text.m-0.font-weight-bold {{ person === 'Client' ? submission?.clientName : person === 'Caregiver' ? submission?.caregiverName : "" }}
                            small.text-muted {{ person }}
                    div(v-if="submission.singleDay.whoGoing.includes('Client') && (event.singleDay.food.lunch.length>0 || event.singleDay.food.beverages.length>0) && person === 'Client'" class="d-flex flex-column" ).mt-2
                        small.p.m-0(v-if="submission.singleDay.client.lunch") Client's Lunch Option
                        b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.client.lunch") {{ submission.singleDay.client.lunch }}
                        div( class="d-flex flex-column" style="" v-if="event.singleDay.food.beverages.length > 0 && submission.singleDay.client.beverage").mt-3
                            small.p.m-0(v-if="submission.singleDay.client.beverage") Client's Beverage Option
                            b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.client.beverage") {{ submission.singleDay.client.beverage }}
                    hr(style="border-top: 1px solid #ccc; margin: 1rem 0;" v-if="submission.singleDay.whoGoing.includes('Client') && submission.singleDay.whoGoing.includes('Caregiver') && (event.singleDay.food.lunch.length>0 || event.singleDay.food.beverages.length>0) && person==='Client'")  
                    div(v-if="submission.singleDay.whoGoing.includes('Caregiver') && (event.singleDay.food.lunch.length>0 || event.singleDay.food.beverages.length>0) && person==='Caregiver'" class="d-flex flex-column").mt-2
                        small.p.m-0(v-if="submission.singleDay.caregiver.lunch") Caregiver's Lunch Option
                        b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.caregiver.lunch") {{ submission.singleDay.caregiver.lunch }}
                        div(v-if="event.singleDay.food.beverages.length > 0 && submission.singleDay.caregiver.beverage" class="d-flex flex-column").mt-3
                            small.p.m-0(v-if="submission.singleDay.caregiver.beverage") Caregiver's Beverage Option
                            b-card-text.m-0.font-weight-bold(v-if="submission.singleDay.caregiver.beverage") {{ submission.singleDay.caregiver.beverage }}
                    hr(style="border-top: 1px solid #ccc; margin: 1rem 0;" v-if="person==='Caregiver' && submission.singleDay.whoGoing.includes('Caregiver') && submission.singleDay.whoGoing.includes('Other Persons') && submission.singleDay.otherPersons.length > 0" )
                    div(v-if="person==='Other Persons' && submission.singleDay.whoGoing.includes('Other Persons') && submission.singleDay.otherPersons.length > 0" class="d-flex flex-column" ).mb-2
                        small.section-label.my-2 Other Persons
                        div(v-for="person in submission.singleDay.otherPersons" :key="person.name" class="d-flex flex-column other-person-card mb-2" style="gap: 0.5rem;")
                            div(class="person-header" style="padding: 0;")
                                span.avatar
                                    b-icon-person-badge
                                b-card-text.m-0.font-weight-bold {{ person.name }}
                            div(class="d-flex flex-column")
                                small.mt-3(v-if="person.lunch") Lunch Option
                                b-card-text.m-0.font-weight-bold(v-if="person.lunch") {{ person.lunch }}
                                div(v-if="event.singleDay.food.beverages.length > 0 && person.beverage" class="d-flex flex-column" )
                                    small.mt-3(v-if="person.beverage") Beverage Option
                                    b-card-text.m-0.font-weight-bold(v-if="person.beverage") {{ person.beverage }}        
                div.info-block.mt-4(v-if="submission?.remarks")
                    small.info-label Remarks You Added
                    b-card-text.p.m-0 {{ submission?.remarks }}
                div.total-price-card.mt-3
                    small.total-price-label Total Price
                    span.total-price-amount $ {{ (Number(submission.totalCost) + (Number(submission.totalCost) * (Number(event.gst) / 100))).toFixed(2) }} (after GST)
                    

            div(v-if="!event.isSingleDay && submission.multipleDays" class="d-flex flex-column" style="")
                
                small.section-label.mb-2.mt-2 People Attending

                div(v-for="person in uniquePeopleMultipleDays" :key="person" style="")
                    div(class="person-header")
                        span.avatar
                            b-icon-person-badge
                        div(class="d-flex flex-column align-items-start")
                            b-card-text.m-0.font-weight-bold(v-if="person === 'Client' || person === 'Caregiver'") {{ person === 'Client' ? submission?.clientName : submission?.caregiverName }}
                            small.text-muted {{ person === 'Other Persons' ? "Other People" : person }}
                        
                
                    div(v-if="submission.multipleDays.whoGoing.includes('Client') && person ==='Client'" class="d-flex flex-column")

                        small.p.mb-1.mt-3 Selected Days for Client:
                        ul(class="list-unstyled" style="padding-left: 0;")
                            li.p.font-weight-bold(v-for="day in submission.multipleDays.client.attendingDays" :key="day") {{ day }}
                    
                        div(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.client.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column mb-2" )
                            small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                            small.p.mb-2.text-primary(v-if="!submission.multipleDays.client.lunchByDay.find(lunch => lunch.dayID === day.id)  && !submission.multipleDays.client.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                
                    hr(style="border-top: 1px solid #ccc; margin: 1rem 0;" v-if="person === 'Client' && submission.multipleDays.whoGoing.includes('Caregiver')")
                    div(v-if="submission.multipleDays.whoGoing.includes('Caregiver')  && person ==='Caregiver'" class="d-flex flex-column" )
                        small.p.mb-1.mt-3 Selected Days for Caregiver:
                        ul(class="list-unstyled" style="padding-left: 0;")
                            li.p.font-weight-bold(v-for="day in submission.multipleDays.caregiver.attendingDays" :key="day") {{ day }}
                        div(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="submission.multipleDays.caregiver.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column" )
                            small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                            b-card-text.m-0.font-weight-bold {{ submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                            small.p.mb-2.text-primary(v-if="!submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id) && !submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)") No Food Options Selected for this day
                        //- b-card-text(v-if="!submission.multipleDays.caregiver.lunchByDay.find(lunch => lunch.dayID === day.id) && !submission.multipleDays.caregiver.beverageByDay.find(beverage => beverage.dayID === day.id)") No Food Options Selected for this day
                    hr(style="border-top: 1px solid #ccc; margin: 1rem 0;" v-if="person === 'Caregiver' && submission.multipleDays.whoGoing.includes('Other Persons')")
                    div(v-if="person === 'Other Persons' && submission.multipleDays.whoGoing.includes('Other Persons')" class="d-flex flex-column" ).mt-2
                        div(v-for="person in submission.multipleDays.otherPersons" :key="person.name" class="d-flex flex-column other-person-card mb-2" )
                            div(class="person-header" style="padding: 0;")
                                span.avatar
                                    b-icon-person-badge
                                b-card-text.m-0.font-weight-bold {{ person.name }}
                            div(class="d-flex flex-column")
                                small.mt-3(v-if="person.attendingDays.length > 0") Selected Days
                                ul.list-unstyled(style="padding-left: 0;")(v-if="person.attendingDays.length > 0")
                                    li.p.font-weight-bold(v-for="day in person.attendingDays" :key="day") {{ day }}
                            div(v-for="(day, index) in event.multipleEvents" :key="day.id" v-if="person.attendingDays.includes(new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}))" class="d-flex flex-column" )
                                small.p.mb-1() Selected Food Option for {{ new Date(day.date).toLocaleDateString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }} 
                                b-card-text.m-0.font-weight-bold {{ person.lunchByDay.find(lunch => lunch.dayID === day.id)?.lunchOption }}
                                b-card-text.m-0.font-weight-bold {{ person.beverageByDay.find(beverage => beverage.dayID === day.id)?.beverageOption }}
                                small.p.mb-2.text-primary(v-if="!person.lunchByDay.find(lunch => lunch.dayID === day.id)  && !person.beverageByDay.find(beverage => beverage.dayID === day.id) ") No Food Options Selected for this day
                div.info-block.mt-4(v-if="submission?.remarks")
                    small.info-label Remarks Added
                    b-card-text.p.m-0.font-weight-bold {{ submission?.remarks }}
                div.total-price-card.mt-3
                    small.total-price-label Total Price
                    span.total-price-amount $ {{ (Number(submission.totalCost) + (Number(submission.totalCost) * (Number(event.gst) / 100))).toFixed(2) }} (after GST)
    template(#modal-footer)
                
        b-button(@click="showModal = false" variant="primary" :disabled="loading") Close
    EditSubmissionModal(v-if="showEditModal" :show.sync="showEditModal" :submission="submission" :event="event" @refresh="refreshReq" @close="showEditModal = false")

</template>

<script>
import axios from "axios";
import EditSubmissionModal from "./EditSubmissionModal.vue";
export default {
    components: {
        EditSubmissionModal
    },
    data(){
        return {
            loading: false,
            showEditModal: false,
        }
    },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    submission: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    uniquePeopleSingleDay() {
      return [...new Set(this.submission.singleDay.whoGoing)];
    },
    uniquePeopleMultipleDays() {
      return [...new Set(this.submission.multipleDays.whoGoing)];
    },
  },
  methods: {
    async refreshReq () {
        console.log("refreshing");
        setTimeout(() => {
            this.$emit("refresh");
        }, 1000);
        this.showModal = false;
        this.showEditModal = false;
    },
    async deleteSubmission(submissionID,eventID,notAttending = false){
            const choice = confirm("Are you sure you want to delete this submission? This action cannot be undone.");
            console.log(submissionID,eventID);
            if(!choice) return;
            if(!submissionID || !eventID) return;
            try{
                this.loading = true;
                const response = await axios.post(`/api/events/v2/deleteSubmission`,{
                    submissionID,
                    eventID,
                    notAttending
                });
                if(response.status === 200){
                    this.$bvToast.toast(`Submission deleted successfully`, {
                        title: "Success",
                        autoHideDelay: 5000,
                        appendToast: true,
                        variant: "success",
                    });
                    this.$emit("submissionDeleted",submissionID);
                }


            }catch(e){
                console.log(e);
                this.$bvToast.toast(`Error deleting submission`, {
                    title: "Error",
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: "danger",
                });
            }
            finally{
                this.loading = false;
                this.showModal = false;
            }
        },
  },
watch: {
    show: {
        immediate: true,
        handler(value) {
            if (value) {
                this.showModal = value;
            }
        }
    },
    submission: {
        immediate: true,
        handler(value) {
            if (value) {
                console.log("new submission", value);
                this.submission = value;
            }
        },
        deep: true
    },
    event: {
        immediate: true,
        handler(value) {
            if (value) {
                console.log("new event", value);
                this.event = value;
            }
        },
        deep: true
    }
  },
};
</script>

<style lang="scss" scoped>
.submission-body {
    padding: 0.5rem 0.25rem 0.25rem;
}

.section-label {
    display: block;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 600;
    color: #8a93a2;
}

.person-header {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    padding: 0.5rem 0;

    .avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #f0ebf7;
        color: #8967b3;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 1rem;
    }
}

.other-person-card {
    border: 1px solid #eef0f4;
    background: #fafbfc;
    border-radius: 12px;
    padding: 0.85rem 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.info-block {
    background: #f8f9fb;
    border: 1px solid #eef0f4;
    border-radius: 12px;
    padding: 0.75rem 1rem;
    text-align: start;
}

.info-label {
    display: block;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-weight: 600;
    color: #8a93a2;
    margin-bottom: 0.25rem;
}

.total-price-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 14px;
    padding: 0.9rem 1.1rem;

    .total-price-label {
        font-size: 0.72rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: 600;
        color: #8a93a2;
        margin-bottom: 0.15rem;
    }

    .total-price-amount {
        font-size: 1.45rem;
        font-weight: 700;
        color: #2e9e5b;
        line-height: 1.2;
    }
}
</style>
